import { Cell } from '@/grid/Cell';
import { EntrancePoint } from './EntrancePoint';

export interface ClusterBounds {
  minRow: number;
  maxRow: number;
  minCol: number;
  maxCol: number;
}

export class Cluster {
  readonly id: number;
  readonly row: number;
  readonly col: number;
  readonly bounds: ClusterBounds;
  readonly cells: Cell[];
  entrancePoints: EntrancePoint[] = [];

  constructor(
    id: number,
    row: number,
    col: number,
    bounds: ClusterBounds,
    cells: Cell[] = []
  ) {
    this.id = id;
    this.row = row;
    this.col = col;
    this.bounds = bounds;
    this.cells = cells;
  }

  addEntrancePoint(entrance: EntrancePoint): void {
    this.entrancePoints.push(entrance);
  }

  containsCell(cell: Cell): boolean {
    return (
      cell.row >= this.bounds.minRow &&
      cell.row <= this.bounds.maxRow &&
      cell.col >= this.bounds.minCol &&
      cell.col <= this.bounds.maxCol
    );
  }

  isOnBoundary(cell: Cell): boolean {
    if (!this.containsCell(cell)) return false;

    const onTopOrBottom =
      cell.row === this.bounds.minRow || cell.row === this.bounds.maxRow;
    const onLeftOrRight =
      cell.col === this.bounds.minCol || cell.col === this.bounds.maxCol;

    return onTopOrBottom || onLeftOrRight;
  }
}
